module.exports = __webpack_public_path__ + "img/Layer 10.52a7e05f.svg";